import React from 'react';
import store from 'store2';

function getStorageValue<T,>(key: string, defaultValue: T) {
    // getting stored value
    const saved = store.get(key);
    const initial = JSON.parse(saved);
    return initial || defaultValue;
}

export const useLocalStorage = (key: string, defaultValue: any) => {


    const [value, setValue] = React.useState(() => {
        return getStorageValue(key, defaultValue);
    });

    React.useEffect(() => {
        // storing input name
        store.set(key, JSON.stringify(value));

    }, [key, value]);

    return [value, setValue];
};
export default { store, useLocalStorage };
